import EditCode from "../../../Components/AdminComponents/editCodes/EditCode";

const EditCodeMainPage = () => {
  return <EditCode />;
};

export default EditCodeMainPage;
